import * as React from "react"
import Button from "./button"

export default function Support() {
  return (
    <div className="mb-[60px] px-5 mx-auto max-w-[1200px]">
      <div className="bg-[#666] h-[1px] mb-[45px]"></div>
      <h2 className="text-pfb-blue text-6xl font-dharma font-light">
        Support PeopleForBikes
      </h2>
      <p className="my-[30px] text-xl leading-8">
        At PeopleForBikes, we know that bikes make life great. Our goal is to
        make the U.S. the best place in the world to ride a bike. With your
        help, we can make that vision a reality.
      </p>
      <div className="mt-10">
        <Button
          text="Donate"
          link="https://www.classy.org/give/117371/#!/donation/checkout"
          type="default"
          color="yellow"
        />
      </div>
    </div>
  )
}
